<template>
  <div class="login">
    <div class="content">
      <div class="glass"></div>
      <div class="info">
        <div class="info_left">
          <img src="../assets/img/login_illustration.png" alt="">
        </div>
        <div class="info_right">
          <h2>MerryHomeFashion</h2>
          <div class="operating" v-show="login===true" >
            <p v-if="loginErrorMessage" style="padding-bottom: 20px; color: red">
              <b>{{ loginErrorMessage }}</b>
            </p>
            <p v-if="newPasswordResetMessage" style="padding:10px; border: 1px, solid rgb(3, 211, 252)">
              <h3>{{ newPasswordResetMessage }}</h3>
            </p>
            <div class="input_box">
              <img src="../assets/img/login_1.png" alt="">
              <el-input v-model="formLabelAlign.username" :placeholder="$t('userName')"></el-input>
            </div>
            <div class="input_box">
              <img src="../assets/img/login_2.png" alt="">
              <el-input v-model="formLabelAlign.password" type="password" :placeholder="$t('password')"></el-input>
            </div>
            <div class="create">
              <span @click="$router.push({path:'/register'})">{{ $t('createAccount') }}</span>
              <span @click="ForgotPassword">{{ $t('forgotPassword') }}</span>
            </div>
            <button @click="Login(formLabelAlign)" class="login_btn">{{ $t('signIn') }}</button>
          </div>
          <div class="operating account" v-show="login===false">
            <!-- <h2>{{ $t('resetPassword') }}</h2> -->
            <p>{{ $t('resetSendEmail') }}</p>
            <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
            <div class="input_box">
              <img src="../assets/img/login_3.png" alt="">
              <el-input v-model="email" placeholder="Email"></el-input>
            </div>
              <button @click="resetEmailRequest(email)" class="login_btn">{{ $t('submit') }}</button>
              <button @click="ForgotPassword" class="login_btn">{{ $t('cancel') }}</button>
              <!-- <span class="pointer" @click="ForgotPassword">{{ $t('cancel') }}</span> -->
          </div>
        </div>
      </div>
    </div>
    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <p v-if="verificationCodeFail" class="red">{{ $t('codeNoMatch') }}</p>
            <div class="code">
              <img src="../assets/img/login_4.png" alt="">
              <el-input autofocus=true placeholder="Verification Code" v-model="verification" v-on:input="sendVerificationCode(verification)"></el-input>
            </div>
            <div class="btn_box">
              <el-button @click="cancelEnteringVerificationCode">{{ $t('cancel') }}</el-button>
              <el-button style="float: right" @click="sendVerificationCode(verification)">{{ $t('submit') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal2" v-if="showChangeToNewPassword">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <p>{{ $t('enterNewPassword') }}</p>
            <div class="code">
              <img src="../assets/img/login_5.png" alt="">
              <el-input autofocus=true placeholder="New Password" type='password' v-model="newpassword"></el-input>
            </div>
            <div class="btn_box box2">
              <el-button @click="resetPasswordRequest(newpassword)">{{ $t('submit') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
​
​
<script>
import { mapActions, mapState } from 'vuex';
import Router from '../router';
import { isUserAuthenticated } from '../store/modules/cart';
function getDefaultData() {
  return {
    labelPosition: 'top',
    formLabelAlign: {
      username: '',
      password: '',
    },
    email:'',
    login:true, //true showlogin; false forget password
    showModal: false,
    showChangeToNewPassword: false,
    newPasswordResetMessage: '',
    verification: '',
    tempToken: '',
    newpassword: '',
    verificationCodeFail: false,
  }
}
export default {
  name: "login",
  data() {
    return {
      labelPosition: 'top',
      formLabelAlign: {
        username: '',
        password: '',
      },
      email:'',
      login:true, //true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: '',
      verification: '',
      tempToken: '',
      newpassword: '',
      couldNotFindEmail: false,
      verificationCodeFail: false,
    }
  },
  methods:{
    ...mapActions('auth', ['LoginRequest', 'resetEmail', 'sentVerificationCode', 'resetPassword']),
    ForgotPassword(){
      this.newPasswordResetMessage = '',
      // this.loginErrorMessage = '',
      this.login = !this.login
    },
    Login(form) {
      this.LoginRequest(form);
    },
    resetEmailRequest(email) {
      this.couldNotFindEmail = false;
      this.resetEmail(email)
      .then(res => {
        this.tempToken = res.data;
        this.showModal = true;
      })
      .catch(err => {
        this.couldNotFindEmail = true;
      })
    },
    resetPasswordRequest(password) {
      this.resetPassword({new_password: password, token: this.tempToken})
      .then(res => {
        Object.assign(this.$data, this.$options.data.call(this));
        this.newPasswordResetMessage = "You have successfully reset your password";
      })
      .catch(err => {
        alert('err resetting the password, please contact Truckxi for more information')
      })
    },
    sendVerificationCode(code) {
      this.verificationCodeFail = false;
      if(code.length < 6) {
        return;
      }
      this.sentVerificationCode({code, token: this.tempToken})
      .then(res=> {
        this.showModal = false;
        this.tempToken = res.data;
        this.showChangeToNewPassword = true;
      })
      .catch(err => {
        console.log('catching error sending verification code', err);
        this.verificationCodeFail = true
      })
    },
    cancelEnteringVerificationCode() {
      this.showModal = false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch('cart/getCart');
      this.$store.dispatch('auth/fetchCustomerInformation');
    } else {
      this.$store.dispatch('cart/fetchCartProducts');
      this.$store.dispatch('auth/fetchCustomerInformation');
    }
    next();
  },  
  computed: mapState({
    loginErrorMessage: state => state.auth.loginErrorMessage
  }),
}
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/login";
</style>


// WEBPACK FOOTER //
// src/view/login.vue